// Routes owned by the JobCategory module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const jobCategoryPaths = {
    jobCategoryList: '/job-categories',
    jobCategoryCreate: '/job-categories/new',
} as const
